import { render, staticRenderFns } from "./ImageViewer.vue?vue&type=template&id=bbb6d2e4&scoped=true&"
import script from "./ImageViewer.vue?vue&type=script&lang=ts&"
export * from "./ImageViewer.vue?vue&type=script&lang=ts&"
import style0 from "./ImageViewer.vue?vue&type=style&index=0&id=bbb6d2e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbb6d2e4",
  null
  
)

export default component.exports